import React from 'react';
import { Button } from '@mui/material';
import './Test.css';

interface IProps {
  onStartClick: () => void;
}

const StartScreen = (props: IProps) => {
  const { onStartClick } = props;

  return (
    <div className="itemTest">
      <h1 className="textStart">Профорієнтаційний тест</h1>
      <div className="buttonStart">
        <Button variant="contained" onClick={onStartClick}>
          Розпочати Тест
        </Button>
      </div>
    </div>
  );
};

export default StartScreen;
